import { render } from "./SelectUser.vue?vue&type=template&id=5dcf8854"
import script from "./SelectUser.vue?vue&type=script&lang=ts"
export * from "./SelectUser.vue?vue&type=script&lang=ts"
script.render = render

export default script